import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPendingOrders } from 'src/redux/orders'
import {
  CTable,
  CTableHead,
  CTableBody,
  CTableRow,
  CTableHeaderCell,
  CTableDataCell,
  CCardBody,
  CSpinner,
  CImage,
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilCheckCircle, cilPlus } from '@coreui/icons'
import { assignOrderToDeliveryBoy, getDeliveryBoys } from 'src/redux/deliveryboys'

const OrdersPending = () => {
  const [visible, setVisible] = useState(false)
  const [selectedOrderId, setSelectedOrderId] = useState()

  const dispatch = useDispatch()
  const { pendingOrders, loading, error } = useSelector((state) => state.orders)
  const { deliveryBoys } = useSelector((state) => state.deliveryboys)

  useEffect(() => {
    dispatch(getPendingOrders())
    dispatch(getDeliveryBoys())
  }, [dispatch])

  if (loading) return <CSpinner color="primary" className="d-block mx-auto my-4" />
  if (error) return <p className="text-danger text-center">Error: {error}</p>
  if (!pendingOrders || pendingOrders.length === 0)
    return <p className="text-center">No orders found</p>

  return (
    <CCardBody>
      <CTable bordered hover responsive>
        <CTableHead color="dark">
          <CTableRow>
            <CTableHeaderCell>#</CTableHeaderCell>
            <CTableHeaderCell>Order Details</CTableHeaderCell>
            <CTableHeaderCell>Total Amount</CTableHeaderCell>
            <CTableHeaderCell>Delivery Charges</CTableHeaderCell>
            <CTableHeaderCell>Coupons Discount</CTableHeaderCell>
            <CTableHeaderCell>Payment Method</CTableHeaderCell>
            <CTableHeaderCell>Customer</CTableHeaderCell>
            <CTableHeaderCell>Products</CTableHeaderCell>
            <CTableHeaderCell>Assign Orders</CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {pendingOrders.map((order, index) => (
            <CTableRow key={order.id}>
              <CTableDataCell>{index + 1}</CTableDataCell>
              <CTableDataCell>
                {order.order_no} <br />
                <strong>{new Date(order.order_date).toLocaleDateString()}</strong> <hr />
                {order.date_slot}
                <br />({order.time_slot})
              </CTableDataCell>
              <CTableDataCell>₹{order.total_amount}</CTableDataCell>
              <CTableDataCell>₹{order.delivery_charges}</CTableDataCell>
              <CTableDataCell>₹{order.coupons_discount}</CTableDataCell>
              <CTableDataCell>{order.payment_method}</CTableDataCell>
              <CTableDataCell>
                {order.full_name}
                <hr />({order.mobile_no})
              </CTableDataCell>
              <CTableDataCell>
                <CTable striped borderless>
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell>Image</CTableHeaderCell>
                      <CTableHeaderCell>Product Name</CTableHeaderCell>
                      <CTableHeaderCell>Price</CTableHeaderCell>
                      <CTableHeaderCell>Quantity</CTableHeaderCell>
                      <CTableHeaderCell>Total</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {order.order_items.map((item) => (
                      <CTableRow key={item.id}>
                        <CTableDataCell>
                          <CImage
                            src={item.images}
                            width={50}
                            height={50}
                            alt={item.name}
                            className="rounded"
                          />
                        </CTableDataCell>
                        <CTableDataCell>{item.name}</CTableDataCell>
                        <CTableDataCell>₹{item.price}</CTableDataCell>
                        <CTableDataCell className="text-center">{item.quantity}</CTableDataCell>
                        <CTableDataCell>₹{item.quantity * item.price}/-</CTableDataCell>
                      </CTableRow>
                    ))}
                  </CTableBody>
                </CTable>
              </CTableDataCell>
              <CTableDataCell>
                <CButton
                  size="sm"
                  color="info"
                  className="text-white"
                  onClick={() => {
                    setVisible(true)
                    setSelectedOrderId(order.id)
                  }}
                >
                  <CIcon icon={cilPlus} className="me-1" />
                  Assign
                </CButton>
              </CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>
      <CModal visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Delivery Boy</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CTable striped hover responsive bordered>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell>#</CTableHeaderCell>
                <CTableHeaderCell>Name</CTableHeaderCell>
                <CTableHeaderCell className="text-center">Mobile</CTableHeaderCell>
                <CTableHeaderCell className="text-center">Status</CTableHeaderCell>
                <CTableHeaderCell className="text-center">Assign</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {deliveryBoys?.map((boy, index) => (
                <CTableRow key={boy.id}>
                  <CTableHeaderCell>{index + 1}</CTableHeaderCell>
                  <CTableDataCell>{boy.name}</CTableDataCell>
                  <CTableDataCell className="text-center">{boy.mobile_no}</CTableDataCell>
                  <CTableDataCell className="text-center">{boy.status}</CTableDataCell>
                  <CTableDataCell className="text-center">
                    <CButton
                      size="sm"
                      color="success"
                      className="text-white"
                      onClick={() => {
                        dispatch(
                          assignOrderToDeliveryBoy({
                            order_id: selectedOrderId,
                            delivery_boy_code: boy.user_code,
                          }),
                        )
                        setVisible(false)
                      }}
                    >
                      <CIcon icon={cilCheckCircle} className="me-1" />
                      Select
                    </CButton>
                  </CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
        </CModalBody>
      </CModal>
    </CCardBody>
  )
}

export default OrdersPending
